import React from 'react';
import './city-ride.css';
import { Link } from "react-router-dom";

function CityRides() {
  return (
    <section className="city-rides" aria-labelledby="city-rides-heading">
      <div className="city-container">
        {/* Hero Section */}
        <div className="city-hero">
          <div className="city-hero-content">
            <h1 id="city-rides-heading" className="city-hero-title">
              Premium City Ride Services
            </h1>
            <p className="city-hero-description">
              Explore the city in comfort and style with our premium ride services. 
              Professional drivers, well-maintained vehicles, and competitive pricing for all your urban transportation needs.
            </p>
            <div className="city-hero-buttons">

                 <Link to="/bookings">
              <button className="city-cta-button primary">Book City Ride</button>  </Link>
       
            </div>
          </div>
          <div className="city-hero-image">
            <img 
              src="/city rides.png" 
              alt="Premium city ride service with comfortable vehicles for urban transportation"
              loading="eager"
              width="600"
              height="400"
            />
          </div>
        </div>

        {/* Service Types */}
        <div className="service-types-section">
          <h2 className="section-title">Our City Ride Options</h2>
          <div className="service-types-grid">
            <div className="service-type-card">
              <div className="service-icon"></div>
              <h3>Standard Rides</h3>
              <p>Comfortable and affordable rides for everyday travel</p>
              <ul className="service-features">
                <li>Up to 4 passengers</li>
                <li>Air conditioning</li>
                <li>GPS tracking</li>
              </ul>
               <Link to="/bookings">
              <button className="service-book-btn">Book Standard</button></Link>
            </div>
            
            <div className="service-type-card">
              <div className="service-icon"></div>
              <h3>Premium Rides</h3>
              <p>Luxury vehicles for business or special occasions</p>
              <ul className="service-features">
                <li>Executive vehicles</li>
                <li>Professional chauffeurs</li>
                <li>Complimentary water</li>
              </ul>
               <Link to="/bookings">
              <button className="service-book-btn">Book Premium</button></Link>
            </div>
            
            <div className="service-type-card">
              <div className="service-icon"></div>
              <h3>Group Rides</h3>
              <p>Spacious vehicles for groups and family travel</p>
              <ul className="service-features">
                <li>Up to 7 passengers</li>
                <li>Extra luggage space</li>
                <li>Child seat options</li>
              </ul>
               <Link to="/bookings">
              <button className="service-book-btn">Book Group</button></Link>
            </div>
          </div>
        </div>

        {/* Pricing Section */}
        <div className="pricing-section">
          <div className="pricing-content">
            <h2 className="section-title">Transparent Pricing</h2>
            <p className="pricing-description">
              No hidden charges. Know exactly what you'll pay before you book.
            </p>
            <div className="pricing-cards">
              <div className="pricing-card">
                <h3>Short Distance</h3>
                <div className="price">$15-25</div>
                <p>Up to 5 miles within city center</p>
                <ul>
                  <li>15-25 minute rides</li>
                  <li>City center coverage</li>
                  <li>Instant booking</li>
                </ul>
              </div>
              
              <div className="pricing-card featured">
                <div className="popular-badge">Most Popular</div>
                <h3>Medium Distance</h3>
                <div className="price">$25-45</div>
                <p>5-15 miles across city</p>
                <ul>
                  <li>25-45 minute rides</li>
                  <li>City-wide coverage</li>
                  <li>Priority booking</li>
                </ul>
              </div>
              
              <div className="pricing-card">
                <h3>Long Distance</h3>
                <div className="price">$45-75</div>
                <p>15+ miles & inter-city</p>
                <ul>
                  <li>45+ minute rides</li>
                  <li>Inter-city travel</li>
                  <li>Advanced booking</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Features Section */}
        <div className="city-features-section">
          <h2 className="section-title">Why Choose Our City Rides</h2>
          <div className="city-features-grid">
            <div className="city-feature-card">
              <div className="feature-number">01</div>
              <h3>24/7 Availability</h3>
              <p>Round-the-clock service for all your travel needs, anytime, anywhere in the city.</p>
            </div>
            <div className="city-feature-card">
              <div className="feature-number">02</div>
              <h3>Real-Time Tracking</h3>
              <p>Track your ride in real-time with live GPS updates and estimated arrival times.</p>
            </div>
            <div className="city-feature-card">
              <div className="feature-number">03</div>
              <h3>Safety First</h3>
              <p>All drivers verified, vehicles regularly inspected, and rides fully insured.</p>
            </div>
            <div className="city-feature-card">
              <div className="feature-number">04</div>
              <h3>Easy Booking</h3>
              <p>Simple and quick booking process with multiple payment options available.</p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="city-cta-section">
          <h2>Ready to Ride Around the City?</h2>
          <p>Book online for the best city ride experience</p>
          <div className="city-cta-buttons">
            
                 <Link to="/bookings">
            <button className="city-cta-button large primary">Book Now</button></Link>
          
          </div>
        </div>
      </div>
    </section>
  );
}

export default CityRides;